// extracted by css-extract-rspack-plugin
export default {"img":"b1Iq0","transition":"Hl1Wj","loaded":"Q4EKH"};